import parsePhoneNumber from "libphonenumber-js";

export function zodPhoneNumberRefine(fieldName: string, errorMessage: string = "Please enter a valid phone number") {
  return (data: any) => {
    if (!data) { return false; }
    const phoneValue = data[fieldName];

    if (!phoneValue || (typeof phoneValue === 'string' && !phoneValue.trim())) {
      return true; // Optional field, empty is valid
    }

    if (typeof phoneValue !== 'string') {
      return false;
    }

    const parsedNumber = parsePhoneNumber(phoneValue, 'US');
    return parsedNumber?.isPossible() ?? false;
  };
}

export function parsePhoneNumberToE164Strict(value: string | undefined): string | undefined {
  if (!value || typeof value !== 'string' || !value.trim()) {
    return undefined;
  }

  const parsedNumber = parsePhoneNumber(value, 'US');
  return parsedNumber?.isValid() ? parsedNumber.format('E.164') : undefined;
}
